import React from "react";
import { Box, BoxProps } from "@mui/material";

export const StyledLogoBox: React.FC<BoxProps> = ({ children, sx, ...rest }) => {
  return (
    <Box
      sx={{
        margin: "5px 0 5px -5px",
        width: 140,
        height: 50,
        maxWidth: 140,
        maxHeight: 50,
        display: "flex",
        zIndex: 1222,
        ...sx
      }}
      {...rest}
    >
      {children}
    </Box>
  );
};

interface StyledLogoImgProps extends Omit<BoxProps, "width" | "height"> {
  src: string;
  alt?: string;
  fadein?: boolean;
  width?: string;
  height?: string;
}

export const StyledLogoImg: React.FC<StyledLogoImgProps> = ({
  fadein = false,
  width = "auto",
  height = "auto",
  sx,
  ...rest
}) => {
  return (
    <Box
      component="img"
      sx={{
        width,
        height,
        opacity: fadein ? 1 : 0,
        transition: "opacity 0.3s ease-in-out",
        ...sx
      }}
      {...rest}
    />
  );
};
